'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommonicdchangesController = function CommonicdchangesController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService) {
  _classCallCheck(this, CommonicdchangesController);

  this.datatableApi;
  this.user = User.getUser();
  this.name = 'Common Coding Changes';
  this.episodeValue = '';
  this.specialtyString = '';
  this.separationString = '';
  this.locale = 'en-au';
  this.url = WEBSERVICEURL + '/dataagility/api/service.episodedg1detail/querychanges?';
  this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '';

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.functionSettings = response.functionSettings;

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === 'string') {
          campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
    });

    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
  });

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {

    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // set the table to a fixed height, so it never collapsed up and down
    $('#auditTable').closest(".dataTables_scrollBody").height(300);
  };

  datePicker.autoClose($scope);

  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
    url: $scope.vm.initUrl,
    // url: '/app/JSON-backup/auditList.json',
    type: 'GET',
    error: function error(xhr, _error, thrown) {
      if (thrown == 'Unauthorized') {
        //window.location.replace(window.location.origin + '/login');
        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
      }
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true)
  // .withOption('serverSide', true)
  .withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($('#auditTable').DataTable());
  }).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[4, 'desc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: 'print',
    text: ''
  }, {
    extend: 'csvHtml5',
    text: '',
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: 'excelHtml5',
    text: '',
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: '',
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]).withColumnFilter({
    //sPlaceHolder: "head:after",
    aoColumns: [{ type: "select" }, {
      type: "text",
      bRegex: true,
      bSmart: true
    }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
  });

  this.dtColumns = [DTColumnBuilder.newColumn('campus').withTitle('Campus').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('diagCode').withTitle('ICD/ACHI Code & Description').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGOccurrence').withTitle('Total Occurrence').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalDRGAudited').withTitle('Total Added').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalRemoved').withTitle('Total Removed').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalChange').withTitle('DRG Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('avgChangePerEpisode').withTitle('Average Change per Episode').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalQueryGeneratedCoder').withTitle('Query Generated by Coder').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalGeneratedAuditor').withTitle('Query Generated by Auditor').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalEpisodeChange').withTitle('Episode Change').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('totalIncompleteDocumentation').withTitle('Incomplete Documentation').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric')];

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];
  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = {};
  this.auditCriteria = {
    selectedCriteria: []
  };
  this.auditCriteriaOptions = {};

  this.locale = 'en-au';

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty($scope.vm.specialtyOptions);
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
      dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, 'days'),
      dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
    }
  };

  // callbacks for lx-selects and lx-date-picker
  this.campusCallback = campusCallback;
  function campusCallback(_newValue, _oldValue) {
    filterDate();
  }

  this.specialtyCallback = specialtyCallback;
  function specialtyCallback(_newValue, _oldValue) {
    filterDate();
  }

  function setDtHeaders(table) {
    $(table.column(1).header()).html($scope.vm.specialtyString);
    $(table.column(7).header()).html($scope.vm.episodeValue + ' Change');
  }

  function selectFilter(column, filter) {

    if (filter) {

      // convert array to datatables permissable regex string
      filter = filter.join("|");

      if (filter !== '') filter = '^' + filter + '$';

      var auditTable = $scope.vm.datatableApi;

      auditTable.columns(column).search(filter, true, false).draw();
    }
  }

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === 'add') {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === 'add') {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  function setDefaultDate() {

    $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
    $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');

    $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
    $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
  }

  function filterDate() {
    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
        endDate = $scope.vm.endDatePicker.input.dateFormatted;
    var campus = '';
    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }
    var url = $scope.vm.url + '&startDate=' + startDate + '&endDate=' + endDate + '&campus=' + checkParam(campus) + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty);
    $scope.vm.datatableApi.ajax.url(url).load().draw();
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  function search() {

    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    var clearAuditTable = auditTable.search('').draw();

    filterSpecialty('minus');

    filterDate();

    // re-draw tabele on datepicker close
    $scope.$on('lx-date-picker__close-start', function (e, id) {

      filterDate();
    });

    // Trigger filtering
    $('.reports__filters').find('div').first().find('div:last-child').click();
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {

    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case 'specialty':
        if (thisModifier === 'add') {
          filterSpecialty('add');
        } else {
          filterSpecialty('minus');
        }
        break;
      case 'campus':
        if (thisModifier === 'add') {
          filterCampus('add');
        } else {
          filterCampus('minus');
        }
        break;
      default:
        break;
    }
  }
};

exports.default = CommonicdchangesController;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchanges/commonicdchanges.controller.js